
define('template!webshopQuotationsView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="list-pane">\n    <div class="list-header">\n        <input type="text" class="search" placeholder="' +
((__t = ( _.i18n('webshop.quotations.search', null, 'Search (reference, customer, e-mail, product)') )) == null ? '' : __t) +
'"/>\n        <div class="filters">\n            <label>' +
((__t = ( _.i18n('common.from', null, 'From') )) == null ? '' : __t) +
' <input type="date" class="from"/></label>\n            <label>' +
((__t = ( _.i18n('common.to', null, 'To') )) == null ? '' : __t) +
' <input type="date" class="to"/></label>\n            <select class="domain">\n                <option value="">' +
((__t = ( _.i18n('webshop.quotations.allSites', null, 'All sites') )) == null ? '' : __t) +
'</option>\n            </select>\n        </div>\n        <div class="total"></div>\n    </div>\n    <div class="list-region"></div>\n</div>\n<div class="detail-region">\n    <div class="detail-placeholder">' +
((__t = ( _.i18n('webshop.quotations.selectQuotation', null, 'Select a quotation to see it') )) == null ? '' : __t) +
'</div>\n</div>\n';

}
return __p
};});

